const Ls3RiesgosRespiracion = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-8 col-xl-6">
                    <h1 className='titulo--lesson--color--1'>Riesgos que enfrentan los <span className='titulo--lesson--color--2'> beb&eacute;s prematuros </span></h1>

                    <h1 className="text--subtitulo p-4">Regular la temperatura corporal</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-2 col-ms-4 col-md-4 col-lg-3 col-xl-1'>
                                <img src="./img/Ls3Termometro.png" className='' />
                            </div>
                            <div className='col-10 col-ms-8 col-md-8 col-lg-9 col-xl-10'>
                                <p className='texto--span ps-lg-4 ps-xl-4'>Los beb&eacute;s prematuros tienen dificultades para regular la temperatura corporal, por lo que son muy sensibles a los cambios de la temperatura ambiental.</p>
                            </div>
                        </div>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls3BabyGorrito.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>La <span className='texto--span'>Organizaci&oacute;n Mundial de la Salud</span> recomienda usar medidas sencillas pero eficaces para mantener la temperatura corporal, como mantener al <span className='texto--span'>beb&eacute; seco y cubierto, cubrir su cabeza con gorros tejidos y usar la t&eacute;cnica madre canguro, manteniendo el contacto piel a piel, en los casos que aplique.</span></p>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>Adaptado de: <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/diseases-conditions/premature-birth/basics/definition/con-20020050'>http://www.mayoclinic.org/diseases-conditions/premature-birth/basics/definition/con-20020050</a></p>
                    </div>

                    <h1 className="text--subtitulo p-4">Respiraci&oacute;n: parte I</h1>

                    <div className='container px-4'>
                        <p className='texto--parrafo'>Los beb&eacute;s prematuros tienen <span className='texto--span'>pulmones m&aacute;s peque&ntilde;os y menos desarrollados</span> que un beb&eacute; a t&eacute;rmino, lo que los hace susceptibles de tener una falla respiratoria.</p>
                    </div>

                    <div className="container p-4">
                        <div className="row d-flex align-items-center">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                                <div className="row">
                                    <img src="./img/Ls3Pulmones.png" className='text-center p-3 Ls3IconPulmones'/>
                                </div>

                                <div className="row d-flex text-center align-self-start">
                                    <div className="col-6">
                                        <p className="text--figuras lh-sm">178 ml Beb&eacute; nacido a t&eacute;rmino</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="text--figuras lh-sm">93 ml Beb&eacute; prematuro</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-6">
                                <p className='texto--parrafo'>Los pulmones de un beb&eacute; prematuro tienen casi la mitad del tama&ntilde;o que los de un beb&eacute; nacido a tiempo.</p>
                            </div>
                        </div>
                    </div>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls3MaquinaRespiracion.png" className='' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--span ps-lg-4 ps-xl-4'>Por esta raz&oacute;n, algunos beb&eacute;s prematuros necesitan un tubo y una m&aacute;quina que los ayude a respirar o la aplicaci&oacute;n de medicamentos que eviten que sus pulmones colapsen.</p>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>Adaptado de: Lagston C, Kida K, Reed M, et al. Am Rev Respir Dis. 1984; 129:607-623 <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/diseases-conditions/premature-birth/
basics/complications/con-20020050'>http://www.mayoclinic.org/diseases-conditions/premature-birth/
                            basics/complications/con-20020050</a></p>
                    </div>

                    <h1 className="text--subtitulo p-4">Respiraci&oacute;n: parte II</h1>

                    <div className='container px-4'>
                        <p className='texto--parrafo'>En ocasiones, los beb&eacute;s prematuros pueden desarrollar una enfermedad pulmonar seria, llamada <span className="texto--span">displasia broncopulmonar</span>, la cual los hace dependientes de ox&iacute;geno suplementario y los hace <span className="texto--span"> m&aacute;s susceptibles de contraer infecciones, en especial por el llamado virus sincitial respiratorio o VSR.</span></p>
                    </div>

                </div>

                <div className="col-md-4 col-lg-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls3BabyGorrito.gif" className='justify-content-start style--image-baby-3' />
                </div>
            </div>
        </div>
    )
}

export default Ls3RiesgosRespiracion;